/**
 * Pure helpers for the header Inspector button (FRONT-692): the activity-aware
 * button — amber with a pulsing dot while background work runs or a chat
 * waits, and a tooltip that says so (`getInspectorTooltip`).
 */

export interface InspectorTooltipInput {
  chatsNeedYou: boolean;
  inspectorActive: boolean;
  activeTaskCount: number;
}

/**
 * FRONT-662: a chat paused on a permission/question takes
 * precedence — it's the more urgent pull-back. Otherwise, if any background
 * work is active, surface the task count (singular/plural). Falls back to the
 * plain label.
 */
export function getInspectorTooltip({
  chatsNeedYou,
  inspectorActive,
  activeTaskCount,
}: InspectorTooltipInput): string {
  if (chatsNeedYou) {
    return 'A chat is waiting for you — open Inspector';
  }
  if (inspectorActive) {
    const taskWord = activeTaskCount === 1 ? 'task' : 'tasks';
    return `${activeTaskCount} ${taskWord} running — open Inspector`;
  }
  return 'Inspector';
}
